import unifapImage from "./unifapImage";
import sortArray from "sort-array";

// import momentjs from "moment";
let pdfMake = require("pdfmake/build/pdfmake");
let pdfFonts = require("pdfmake/build/vfs_fonts");
pdfMake.vfs = pdfFonts.pdfMake.vfs;

export default function(title, inscriptions) {
  const inscriptionsPerCourse = {};
  for (const inscription of inscriptions) {
    if (inscription.is_paid || inscription.accepted_isencao) {
      if (inscriptionsPerCourse[inscription.course]) {
        inscriptionsPerCourse[inscription.course] += 1;
      } else {
        inscriptionsPerCourse[inscription.course] = 1;
      }
    }
  }

  const courses = Object.keys(inscriptionsPerCourse);
  const inscriptionsPerCourseFormated = [];
  //   const totalInscriptions = 0;
  for (const course of courses) {
    inscriptionsPerCourseFormated.push([course, inscriptionsPerCourse[course]]);
    // totalInscriptions += inscriptionsPerCourse[course];
  }

  const sorted = sortArray(inscriptionsPerCourseFormated, {
    by: [0],
    order: "asc",
    // computed: {
    //   inscriptionNumber: (row) => row.id_user.inscriptionNumber,
    //   name: (row) => row.id_user.name,
    //   cpf: (row) => row.vacancie.cpf,
    //   enemYear: (row) => row.vacancie.enemYear,
    // },
  });
 
  let doc = {
    content: [
      { text: " ", fontSize: 8 },
      { text: title, alignment: "center" },
      { text: "Relatório de Inscritos", alignment: "center" },
      {
        table: {
          headerRows: 1,
          widths: ["*", 65],
          body: [
            [
              {
                text: "CURSO",
                alignment: "center",
                bold: true,
              },
              {
                text: "INSCRITOS",
                alignment: "center",
                bold: true,
              },
            ],
            ...sorted,
          ],
        },
      },
    ],
  };
  //   doc.pageOrientation = "landscape";
  doc.pageMargins = [40, 100, 40, 60];
  doc.header = {
    margin: 10,
    alignment: "center",
    columns: [
      [
        {
          width: 20,
          image: unifapImage,
        },
        { text: "MINISTÉRIO DA EDUCAÇÃO", bold: true },
        { text: "UNIVERSIDADE FEDERAL DO AMAPÁ", bold: true },
        {
          text: "DEPARTAMENTO DE PROCESSOS SELETIVOS E CONCURSOS",
          alignment: "center",
          bold: true,
        },
        {
          text:
            "Rod. Juscelino Kubitschek Km 2, Jardim Marco Zero – Macapá-AP, CEP 68.903-419 www.unifap.br",
          fontSize: 8,
        },
      ],
    ],
  };
  pdfMake.createPdf(doc).download(`Relatório de Inscritos - ${title}.pdf`);
}
